import React from "react";

const services = [
    {
        icon: "🥳",
        role: "Animatorka",
        name: "AnimaVocali",
        info: "Instagram: animavocali",
        hours: "18:00 — 21:00",
        color: "grape",
    },
    {
        icon: "📸",
        role: "Fotobudka",
        name: "Extrabudka",
        info: "Instagram: extrabudka",
        hours: "20:00 — 23:00",
        color: "orange",
    },
    {
        icon: "🍹",
        role: "Cocktail Bar",
        name: "Indygo Cocktail Bar",
        info: "Instagram: indygococktail",
        hours: "Po pierwszym tańcu — 02:00",
        color: "lime",
    },
    {
        icon: "📸",
        role: "Fotograf i Kamerzysta",
        name: "InColor Kamil Sputo",
        info: "Instagram: incolor.kamilsputo",
        hours: "Z nami już od samych przygotowań — 1:00",
        color: "orange",
    },
    {
        icon: "🎤",
        role: "Zespół ",
        name: "Prezydent",
        info: "Instagram: zespolprezydent",
        hours: "Do ostatniego gościa na parkiecie ",
        color: "grape",
    },
];

function Services() {
    return (
        <div className="services">
            <div className="services-inner">
                <div className="eyebrow grape" style={{ justifyContent: "center" }}>
                    Ekipa wesela
                </div>
                <h2 className="sec-title" style={{ textAlign: "center", marginBottom: "48px" }}>
                    Nasi <em>usługodawcy</em>
                </h2>

                <div className="services-grid">
                    {services.map((service, index) => (
                        <div key={index} className={`service-card service-card--${service.color}`}>
                            <div className="service-icon">{service.icon}</div>
                            <div className="service-content">
                                <div className="service-role">{service.role}</div>
                                <div className="service-name">{service.name}</div>
                                <div className="service-info">
                                    <a
                                        href={`https://www.instagram.com/${service.info.replace("Instagram: ", "")}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="service-instagram"
                                    >
                                        📸 {service.info}
                                    </a>
                                </div>
                                <div className="service-hours">
                                    <span className="service-hours-icon">🕐</span>
                                    {service.hours}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Services;